import { useState } from "react";
import { Link as LinkIcon, Check } from "lucide-react";

/**
 * Small share row for blog posts / case studies. Uses window at click time
 * (never during render) so it's SSR-safe.
 */
export function ShareLinks({ title, path }: { title: string; path: string }) {
  const [copied, setCopied] = useState(false);

  const getUrl = () => {
    if (typeof window === "undefined") return path;
    return `${window.location.origin}${path}`;
  };

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(getUrl());
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch {
      /* ignore */
    }
  };

  const shareOnX = () => {
    const url = encodeURIComponent(getUrl());
    const text = encodeURIComponent(title);
    window.open(`https://twitter.com/intent/tweet?url=${url}&text=${text}`, "_blank", "noopener");
  };

  const shareOnLinkedIn = () => {
    const url = encodeURIComponent(getUrl());
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${url}`, "_blank", "noopener");
  };

  const base =
    "inline-flex items-center gap-2 rounded-full border border-border px-4 py-2 font-mono text-[0.65rem] uppercase tracking-[0.22em] text-muted-foreground transition-colors hover:border-sun hover:text-sun";

  return (
    <div className="flex flex-wrap items-center gap-3">
      <span className="font-mono text-[0.65rem] uppercase tracking-[0.22em] text-muted-foreground">
        Share
      </span>
      <button type="button" onClick={shareOnX} className={base} aria-label="Share on X">
        X
      </button>
      <button
        type="button"
        onClick={shareOnLinkedIn}
        className={base}
        aria-label="Share on LinkedIn"
      >
        LinkedIn
      </button>
      <button type="button" onClick={onCopy} className={base} aria-label="Copy link">
        {copied ? <Check className="h-3.5 w-3.5" /> : <LinkIcon className="h-3.5 w-3.5" />}
        {copied ? "Copied" : "Copy link"}
      </button>
    </div>
  );
}
